import { Injectable } from '@angular/core';
import { InteractionStatus } from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';
import { TestUser } from './test-login.service';

@Injectable({
  providedIn: 'root',
})
export class TestMsalService {
  private currentUserSubject = new BehaviorSubject<TestUser | null>(null);
  private inProgressSubject = new BehaviorSubject<InteractionStatus>(InteractionStatus.None);

  public currentUser$ = this.currentUserSubject.asObservable();
  public inProgress$ = this.inProgressSubject.asObservable();

  constructor() {
    // Don't initialize from localStorage - let user login manually
    console.log('[TestMsalService] Initialized without auto-login');
  }

  setCurrentUser(user: TestUser): void {
    this.currentUserSubject.next(user);
    localStorage.setItem('cypress-test-user', this.getUserTypeFromUser(user));
  }

  getCurrentUser(): TestUser | null {
    return this.currentUserSubject.value;
  }

  getActiveAccount(): any {
    const user = this.getCurrentUser();
    if (!user) {
      return null;
    }

    return {
      homeAccountId: `${user.oid}.6e63ffc0-c2fc-4cc4-b6c4-666b2ce89d92`,
      localAccountId: user.oid,
      username: user.email,
      environment: 'login.windows.net',
      tenantId: '6e63ffc0-c2fc-4cc4-b6c4-666b2ce89d92',
      name: user.name,
      idTokenClaims: {
        aud: '6b79bf94-8a9e-4a78-ad23-de2e7dc13ee3',
        exp: (Date.now() / 1000 + 3600).toString(),
        name: user.name,
        oid: user.oid,
        preferred_username: user.email,
        roles: user.roles,
        tid: '6e63ffc0-c2fc-4cc4-b6c4-666b2ce89d92',
      },
    };
  }

  getAllAccounts(): any[] {
    const account = this.getActiveAccount();
    return account ? [account] : [];
  }

  private getUserTypeFromUser(user: TestUser): string {
    if (user.roles.includes('LabPartner.Administrators')) {
      return 'admin';
    }
    if (user.roles.includes('LabPartner.Writers')) {
      return 'writer';
    }
    return 'reader';
  }

  // Mock methods that return promises
  loginRedirect(): Promise<void> {
    return Promise.resolve();
  }

  logout(): Promise<void> {
    this.currentUserSubject.next(null);
    localStorage.removeItem('cypress-test-user');
    return Promise.resolve();
  }

  acquireTokenSilent(): Promise<{ accessToken: string }> {
    return Promise.resolve({ accessToken: 'mock-token' });
  }

  acquireTokenPopup(): Promise<{ accessToken: string }> {
    return Promise.resolve({ accessToken: 'mock-token' });
  }

  acquireTokenRedirect(): Promise<void> {
    return Promise.resolve();
  }

  handleRedirectPromise(): Promise<any> {
    return Promise.resolve(null);
  }

  setActiveAccount(): void {
    // Mock implementation
  }

  clearCache(): void {
    this.currentUserSubject.next(null);
    localStorage.removeItem('cypress-test-user');
  }
}
